import React from "react";
import DirectoryView from "./DirectoryView";
import {compose} from "redux";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as R from "ramda";
import {
  createFolder,
  deleteFile,
  getFileArchiveLink,
  getFileLink,
  getFiles, renameFile,
  setFileIsAddendum,
  uploadFiles
} from "../../actions/files";
import {withLoading} from "./deferLoaderHoc";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import {clearArchivePending} from "../../reducers/ui";
import {ackNotifications} from "../../actions/notifications";
import {BID} from "../../services";
import AddendumCount from "../Bids/AddendumCount";

const buildPathTree = (items, topLevelName) => {
  let newTree = {
    tree: {
      '/': {
        label: topLevelName,
        path: '/',
        _children: {}
      }
    },
    list: items,
  };
  let pathLens = R.pipe(
    R.intersperse('_children'),
    R.lensPath
  );
  items.filter(item => item.mimetype === 'application/x-directory').forEach(item => {
    let insertPath = ['/', ...item.path.replace(/^\//,'').split('/').filter(x => x), item.name];
    let newItem = {
      label: item.name,
      path: R.pipe(
        R.split('/'),
        R.filter(x => x),
        R.append(item.name),
        R.map(x => '/' + x),
        R.join('')
      )(item.path)
    };
    newTree.tree = R.over(pathLens(insertPath), prev => R.mergeLeft(prev, newItem), newTree.tree);
  });
  return newTree;
};

const fileSelector = (indexType, matchKey, topLevelName) => {
  return createSelector(
    state => state.files,
    (state, props) => R.view(R.lensPath(matchKey), props),
    (files, id) => {
      let list = files.indexes[indexType][id];
      if (!list) {
        return null;
      }
      list = Object.keys(list).map(id => files.data[id]).filter(i => i);
      return buildPathTree(list, topLevelName);
    }
  );
};

const archiveStatusSelector = (matchKey) => createSelector(
  state => state.ui.archivesPending,
  (state, props) => R.view(R.lensPath(matchKey), props),
  (archivesPending, id) => R.view(R.lensPath([id]), archivesPending)
);

export const FileController = (docType, indexType, docKey, subDocKey, topLevelName, displayControls = true) => {
  const thisFileSelector = subDocKey ? fileSelector(indexType, subDocKey, topLevelName) : fileSelector(indexType, docKey, topLevelName);
  const thisArchiveSelector = subDocKey ? archiveStatusSelector(subDocKey) : archiveStatusSelector(docKey);
  return compose(
    withRouter,
    connect(
      (state, props) => {
        let files = thisFileSelector(state, props);
        if (!files) return { loading: true };
        const docId = docKey ? R.view(R.lensPath(docKey), props) : null;
        const subDocId = subDocKey ? R.view(R.lensPath(subDocKey), props) : null;
        const permissions = subDocId ? state.view.subview.data[subDocId].permissions : state.view.data[docId].permissions;
        return {
          permissions,
          fileTree: files,
          archive: thisArchiveSelector(state, props),
          uploading: R.path(['files', 'indexes', indexType, R.view(R.lensPath(subDocKey ? subDocKey : docKey), props), 'metadata'], state),
          displayControls,
        };
      },
      (dispatch, props) => {
        const docId = docKey ? R.view(R.lensPath(docKey), props) : null;
        const subDocId = subDocKey ? R.view(R.lensPath(subDocKey), props) : null;
        let onSetAddendum, controlsExtra;
        controlsExtra = <span/>;
        if (docType === BID) {
          onSetAddendum = (fileId, isAddendum) => dispatch(setFileIsAddendum(docType, docId, subDocId, fileId, isAddendum));
          controlsExtra = <AddendumCount bidId={docId}/>;
        }
        return {
          loader: () => dispatch(getFiles(docType, docId, subDocId)),
          onDownload: (item) => dispatch(getFileLink(docType, docId, subDocId, item.id)),
          onUpload: (path, files) => dispatch(uploadFiles(docType, docId, subDocId, path, files)),
          onRename: (item, name) => dispatch(renameFile(docType, docId, subDocId, item.id, name)),
          onDelete: (fileId) => dispatch(deleteFile(docType, docId, subDocId, fileId)),
          onDeleteFolder: (fileId) => dispatch(deleteFile(docType, docId, subDocId, fileId)),
          onNewFolder: (path, newFolderName) => dispatch(createFolder(docType, docId, subDocId, path, newFolderName)),
          onDownloadArchive: () => dispatch(getFileArchiveLink(docType, docId, subDocId)),
          onArchiveClear: (archiveId, notificationId) => {
            dispatch(clearArchivePending(archiveId));
            dispatch(ackNotifications([notificationId]));
          },
          onSetAddendum,
          controlsExtra
        };
      }
    ),
    withLoading
  )(DirectoryView);
};



// WEBPACK FOOTER //
// ./src/components/Boilerplate/FileController.js